// src/App.js
import Sidebar from "./components/Sidebar";
import RoutesConfig from "./routes";
import "./styles/global.css";

const App = () => {
  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <Sidebar />
      <RoutesConfig />
    </div>
  );
};

export default App;
